import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Link as LinkButton } from '@bingads-webui-react/fabric-control';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getTopKeyCardStyles } from '../../styles/top-key-card';
import { BudgetActionType } from '../../constants';

export function BudgetActions({
  i18n, isAuth, budgetId, handleClick, openBudgetUpdatePanel, navigateBySiteMapId, type,
}) {
  const classes = useDefaultStyles(getTopKeyCardStyles);
  const actionClickApi = type === BudgetActionType.LifetimeBudget ?'ActionClick-EditLifetimeBudget' : 'ActionClick-EditDailyBudget';

  return (
    <>
      {isAuth &&
        <LinkButton
          as="button"
          className={classnames(`campaign-${type}-budget-action`, 'edit-budget-link', classes.CampaignEditLink)}
          onClick={() => handleClick({
            api: actionClickApi,
            action: openBudgetUpdatePanel,
          })}
        >
          {i18n.getString(_TL_('Edit'))}
        </LinkButton>}
      {budgetId > 0 &&
        <LinkButton
          as="button"
          className={classnames(`campaign-${type}-budget-action`, 'shared-budget-link')}
          onClick={() => handleClick({
            api: 'ActionClick-SharedBudgetPage',
            action: () => navigateBySiteMapId('shared-budgets-edit', { extraSearch: { budgetId } }),
          })}
        >
          {i18n.getString(_TL_('Shared budgets'))}
          <Glyphicon glyph="ba-OpenInNewWindow" className={classnames('shared-budget-link-icon', classes.CampaignSharedIcon)} />
        </LinkButton>}
    </>
  );
}

BudgetActions.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  isAuth: PropTypes.bool.isRequired,
  budgetId: PropTypes.number,
  handleClick: PropTypes.func.isRequired,
  openBudgetUpdatePanel: PropTypes.func.isRequired,
  navigateBySiteMapId: PropTypes.func.isRequired,
  type: PropTypes.oneOf([BudgetActionType.DailyBudget, BudgetActionType.LifetimeBudget]).isRequired,
};

BudgetActions.defaultProps = {
  budgetId: null,
};
